import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { 
  CANCEL_TOPIC_CREATION_MODAL_I18N_KEYS as MY_I18N_KEYS, 
  CANCEL_TOPIC_CREATION_MODAL_I18N_PREFIX as MY_I18N_PREFIX 
 } from '../constants/i18n/CancelTopicCreationModali18nConstants';


class CancelTopicCreationModal extends Component {
  static propTypes = {
    show:        PropTypes.bool.isRequired,
    toggleModal: PropTypes.func.isRequired,
    handleUploadedFileTopicCreationCancellation:                 PropTypes.func.isRequired,
    handleReturnBackToPreviousModalFromCancelTopicCreationModal: PropTypes.func.isRequired
  };

  getI18nText(textKey) {
    return t(MY_I18N_PREFIX + "." + textKey);
  }

  handleCancelTopicCreationButton = () => {
    const {
      toggleModal,
      handleUploadedFileTopicCreationCancellation 
    } = this.props;

    toggleModal(false);
    handleUploadedFileTopicCreationCancellation();
  }

  render() {
    const { 
      show,
      handleReturnBackToPreviousModalFromCancelTopicCreationModal 
    } = this.props;

    return (
      <div className={`modal create-upload-data-topic-modal cancel-topic-creation-modal ${show ? 'modal-show' : 'modal-hide'}`}>
        <div className="cancel-topic-creation-modal-dialog">
          <div className="cancel-topic-creation-modal-content">
            <div className="cancel-topic-creation-modal-header">
              <span className="cancel-topic-creation-modal-title">
                {this.getI18nText(MY_I18N_KEYS.modal_title)}
              </span>
            </div>
            <div className="cancel-topic-creation-modal-body">
              <p>
                {this.getI18nText(MY_I18N_KEYS.paragraph_1)}
              </p>
              <p>
                {this.getI18nText(MY_I18N_KEYS.paragraph_2)}
              </p>
            </div>
            <div className="cancel-topic-creation-modal-footer">
              <button
                className='btn variable-width-btn'
                onClick={this.handleCancelTopicCreationButton}
              >
                {this.getI18nText(MY_I18N_KEYS.cancel_topic_creation_button_text)}
              </button>
              <button
                className='btn btn-submit variable-width-btn'
                onClick={handleReturnBackToPreviousModalFromCancelTopicCreationModal}
              >
                {this.getI18nText(MY_I18N_KEYS.back_button_text)}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CancelTopicCreationModal;


// WEBPACK FOOTER //
// ./src/features/topics/components/file-upload/CancelTopicCreationModal.js